import { Link } from "@tanstack/react-router"
import type { ReactNode } from "react"

interface OrchardFieldLayoutProps {
  children: ReactNode
}

export function OrchardFieldLayout({ children }: OrchardFieldLayoutProps) {
  return (
    <div className="min-h-svh bg-[radial-gradient(circle_at_top,rgba(108,153,83,0.18),transparent_38%),linear-gradient(180deg,#f8f6ee_0%,#f0ede1_100%)] px-4 py-5 sm:px-6 lg:px-8">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6">
        <section className="overflow-hidden rounded-[2rem] border border-emerald-900/10 bg-white/80 shadow-[0_20px_60px_rgba(64,88,43,0.08)] backdrop-blur">
          <div className="grid gap-6 px-5 py-5 sm:px-7 sm:py-7 lg:grid-cols-[minmax(0,1.4fr)_minmax(260px,0.7fr)] lg:items-start">
            <div className="flex flex-col gap-4">
              <div className="inline-flex w-fit items-center rounded-full border border-emerald-900/10 bg-emerald-900/5 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-900/75">
                GrowBetter Orchard Intelligence
              </div>
              <div className="space-y-3">
                <h1 className="font-heading text-3xl leading-tight tracking-tight text-emerald-950 sm:text-4xl">
                  Tree Scan Workspace
                </h1>
                <p className="max-w-3xl text-sm leading-7 text-emerald-950/70 sm:text-base">
                  Built for fast field logging. Scan a tree, confirm its orchard context,
                  and capture flowering, fruit load, harvest, and health observations
                  without the broader SafetyQR public-site framing.
                </p>
              </div>
            </div>

            <div className="rounded-[1.5rem] border border-emerald-900/10 bg-[linear-gradient(180deg,rgba(242,247,236,0.95),rgba(231,239,221,0.95))] px-5 py-5 text-sm text-emerald-950/78 shadow-inner">
              <div className="text-xs font-semibold uppercase tracking-[0.18em] text-emerald-900/60">
                Field flow
              </div>
              <div className="mt-3 space-y-2 leading-6">
                <p>1. Scan the QR fixed on the tree.</p>
                <p>2. Verify block, row, variety, and recent history.</p>
                <p>3. Save seasonal observations for yield and orchard health.</p>
              </div>
              <div className="mt-4">
                <Link
                  className="inline-flex items-center rounded-full border border-emerald-900/10 bg-white px-3 py-2 text-xs font-medium text-emerald-950 transition hover:border-emerald-900/20 hover:bg-emerald-50"
                  to="/"
                >
                  Back to main site
                </Link>
              </div>
            </div>
          </div>
        </section>

        {children}
      </div>
    </div>
  )
}
